import axios, { AxiosRequestConfig } from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  IFetchWorkspacesPayload,
  IRenameAccountPayload,
  IChangeAvatarPayload,
  IChangeTranslationProviderCredentialsPayload,
  IMoveProjectsToOtherWorkspacePayload,
} from './types'

const config: AxiosRequestConfig = {
  responseType: 'json'
}

export function fetchWorkspaces(payload: IFetchWorkspacesPayload) {
  return axios.get(`/api/v1/accounts/${payload.accountId}/show_workspaces`)
}

export function renameAccount(payload: IRenameAccountPayload) {
  return axios.put(`/api/v1/accounts/${payload.accountId}/rename`, convertToSnakeCase(payload), config)
}

export function changeAvatar(payload: IChangeAvatarPayload) {
  return axios.post(`/api/v1/accounts/${payload.accountId}/change_avatar`, convertToSnakeCase(payload), config)
}

export function changeTranslationProviderCredentials(payload: IChangeTranslationProviderCredentialsPayload) {
  return axios.post(`/api/v1/accounts/${payload.accountId}/change_translation_provider_credentials`, convertToSnakeCase(payload), config)
}

export function moveProjectsToOtherWorkspace(payload: IMoveProjectsToOtherWorkspacePayload) {
  return axios.post(`/api/v1/accounts/${payload.accountId}/move_projects_to_other_workspace`, convertToSnakeCase(payload), config)
}
